module.exports = __webpack_public_path__ + "img/list24.512187b0.jpeg";